import React from "react";

import Header from "./components/header/Header";
import Footer from "./components/footer/Footer";
import CssBaseline from "@material-ui/core/CssBaseline";

import { createMuiTheme, MuiThemeProvider } from "@material-ui/core/styles";
import indigo from "@material-ui/core/colors/indigo";
import pink from "@material-ui/core/colors/pink";
import Main from "./components/main/Main";

const theme = createMuiTheme({
  palette: {
    primary: indigo,
    secondary: pink
  },
  typography: {
    useNextVariants: true
  }
});

export const App = () => (
  <>
    <CssBaseline />
    <MuiThemeProvider theme={theme}>
      <Header />
      <Main />
      <Footer />
    </MuiThemeProvider>
  </>
);
